var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegister(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 120,
    viewBox: "0 0 123 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 41.5,
    width: 87,
    height: 78,
    rx: 4.5,
    fill: "#E7EDF3",
    stroke: "#BCC4D6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.84672 28.653L87.5535 33.4442C90.0341 33.5972 91.921 35.732 91.768 38.2126L89.6505 72.557C88.308 94.3309 69.5684 110.894 47.7945 109.551L5.02138 106.914C2.54081 106.761 0.653892 104.626 0.806837 102.146L5.07831 32.8676C5.23126 30.387 7.36614 28.5001 9.84672 28.653Z",
    fill: "#F1F5FA",
    stroke: "#BCC4D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1485 89.2401C65.426 96.0524 64.4208 102.101 58.5 108.5C75.2327 107.386 85.4851 91.256 86 86.5C73.901 89.9349 63.1209 83.7602 64.1485 89.2401Z",
    fill: "#CCD2E0",
    stroke: "#BCC4D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6087 97L4.47795 98.3728C4.21462 101.138 6.25525 103.587 9.02228 103.828L11 104",
    stroke: "#BCC4D6",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88 116H89C91.7614 116 94 113.761 94 111V110",
    stroke: "#BCC4D6",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.125 39.9755L57.9011 28.1917",
    stroke: "#BCC4D6",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5 27.5C65.5 31.9473 62.114 35.5 58 35.5C53.886 35.5 50.5 31.9473 50.5 27.5C50.5 23.0527 53.886 19.5 58 19.5C62.114 19.5 65.5 23.0527 65.5 27.5Z",
    fill: "#F1F5FA",
    stroke: "#BCC4D6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1897 62C32.2477 63.5667 33.491 66.7458 38.0002 66.9283C42.5095 67.1108 44.1268 64.0475 44.3719 62.493",
    stroke: "#8894AC",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9314 62.7585C50.9894 64.3252 52.2327 67.5042 56.7419 67.6867C61.2512 67.8692 62.8685 64.8059 63.1136 63.2515",
    stroke: "#8894AC",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M103.727 41C103.546 41 103.398 40.9716 103.282 40.9149C103.174 40.8582 103.098 40.7816 103.054 40.6851C103.018 40.583 103.018 40.4723 103.054 40.3532C103.098 40.2284 103.181 40.1007 103.304 39.9702L107.448 35.5617V35.9106H103.618C103.416 35.9106 103.26 35.8709 103.152 35.7915C103.051 35.7121 103 35.5986 103 35.4511C103 35.3035 103.051 35.1929 103.152 35.1191C103.26 35.0397 103.416 35 103.618 35H108.11C108.291 35 108.436 35.0284 108.544 35.0851C108.66 35.1418 108.736 35.2184 108.772 35.3149C108.816 35.4113 108.816 35.522 108.772 35.6468C108.736 35.7716 108.656 35.8993 108.533 36.0298L104.389 40.4298V40.0894H108.382C108.584 40.0894 108.736 40.1291 108.837 40.2085C108.946 40.2823 109 40.3929 109 40.5404C109 40.6879 108.946 40.8014 108.837 40.8809C108.736 40.9603 108.584 41 108.382 41H103.727Z",
    fill: "#5D6A86"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M115.969 29C115.728 29 115.53 28.9527 115.376 28.8582C115.231 28.7636 115.13 28.6359 115.072 28.4752C115.024 28.305 115.024 28.1206 115.072 27.922C115.13 27.7139 115.241 27.5012 115.405 27.2837L120.931 19.9362V20.5177H115.825C115.555 20.5177 115.347 20.4515 115.203 20.3191C115.068 20.1868 115 19.9976 115 19.7518C115 19.5059 115.068 19.3215 115.203 19.1986C115.347 19.0662 115.555 19 115.825 19H121.814C122.055 19 122.248 19.0473 122.392 19.1418C122.547 19.2364 122.648 19.3641 122.696 19.5248C122.754 19.6856 122.754 19.87 122.696 20.078C122.648 20.2861 122.542 20.4988 122.378 20.7163L116.852 28.0496V27.4823H122.175C122.445 27.4823 122.648 27.5485 122.783 27.6809C122.928 27.8038 123 27.9882 123 28.234C123 28.4799 122.928 28.669 122.783 28.8014C122.648 28.9338 122.445 29 122.175 29H115.969Z",
    fill: "#5D6A86"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M102.212 14C101.91 14 101.663 13.9338 101.47 13.8014C101.289 13.669 101.163 13.4903 101.09 13.2652C101.03 13.027 101.03 12.7688 101.09 12.4908C101.163 12.1995 101.301 11.9017 101.506 11.5972L108.414 1.31064V2.12482H102.031C101.693 2.12482 101.434 2.03215 101.253 1.84681C101.084 1.66147 101 1.39669 101 1.05248C101 0.708275 101.084 0.450118 101.253 0.278014C101.434 0.0926714 101.693 0 102.031 0H109.517C109.819 0 110.06 0.0661938 110.241 0.198581C110.433 0.330969 110.56 0.509692 110.62 0.734752C110.693 0.959811 110.693 1.21797 110.62 1.50922C110.56 1.80047 110.427 2.09834 110.222 2.40284L103.315 12.6695V11.8752H109.969C110.307 11.8752 110.56 11.9678 110.729 12.1532C110.91 12.3253 111 12.5835 111 12.9277C111 13.2719 110.91 13.5366 110.729 13.722C110.56 13.9073 110.307 14 109.969 14H102.212Z",
    fill: "#5D6A86"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 78,
    r: 2,
    fill: "#5D6A86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegister);
export default __webpack_public_path__ + "static/media/register.8c2313b23c088086f1e384557805496b.svg";
export { ForwardRef as ReactComponent };